import { render, staticRenderFns } from "./ProspectQuestions.vue?vue&type=template&id=888cd232&scoped=true"
import script from "./ProspectQuestions.vue?vue&type=script&lang=js"
export * from "./ProspectQuestions.vue?vue&type=script&lang=js"
import style0 from "./ProspectQuestions.vue?vue&type=style&index=0&id=888cd232&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "888cd232",
  null
  
)

export default component.exports